export default __webpack_public_path__ + "static/fml_brochure-63f5e73380c9c46a950fd78e1d16b8dd.pdf";